import { supabase } from "@/integrations/supabase/client";
import { FunctionsError } from "@supabase/supabase-js";

/**
 * Verifies a mailbox exists in Microsoft 365 and gets its details
 */
export async function verifyMailbox(email: string): Promise<any> {
    try {
        // Get the tenant ID from the current session
        const { data: { session } } = await supabase.auth.getSession();
        const tenant_id = session?.user?.app_metadata?.tenant_id;

        if (!tenant_id) {
            throw new Error("No tenant ID available in the current session");
        }

        // Call the graph-mailbox Edge Function with email and tenant_id
        const { data, error } = await supabase.functions.invoke("graph-mailbox", {
            body: { email, tenant_id }
        });

        if (error) {
            if (error instanceof FunctionsError && error.context?.body) {
                const resp = new Response(error.context.body as ReadableStream);
                const errorBody = await resp.json();

                if (errorBody?.error) throw new Error(errorBody.error);
            }
            throw error;
        }
        return data;
    } catch (error) {
        console.error("Error verifying mailbox:", error);
        throw error;
    }

}
